import { Button } from "@mui/material";

const IntroStep = ({ props }) => (
    <div className={`content-bea ${props.isModalOpen ? "blurred" : ""}`}>
        <p>
            We are happy to receive your request for support and work with you towards high quality infectious disease care everywhere.
        </p>
        <p>
             By filling out the form below, we can gain an understanding of your needs and the context you work in. We will review your application, and get back in touch with you regarding the matching procedure as soon as possible.
        </p>
        <p>
            If you have any questions in the meantime, please don’t hesitate to reach out to us at <a href="info@spice-global.org">info@spice-global.org</a>
        </p>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button onClick={props.handleBeginRegistration} variant="contained" color="primary" fullWidth>Begin Registration</Button>
        </div>
    </div>
);

export default IntroStep;